var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFunnelTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71.8525,
    cy: 71.8534,
    r: 71.5087,
    fill: "#EDF1FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.0531 93.4536C82.3173 93.4536 84.1531 95.267 84.1531 97.5036C84.1531 99.7448 82.322 104.254 80.0531 104.254C77.7842 104.254 75.9531 99.7448 75.9531 97.5036C75.9531 95.267 77.7889 93.4536 80.0531 93.4536Z",
    fill: "#FF9349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8874 84.0034L84.154 88.0534H75.954L73.2207 84.0034H86.8874Z",
    fill: "#FF9349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7855 66.4535C82.7855 64.9624 81.5617 63.7535 80.0522 63.7535C78.5427 63.7535 77.3189 64.9624 77.3189 66.4535C77.3189 67.9446 78.5427 69.1535 80.0522 69.1535C81.5597 69.1489 82.7808 67.9426 82.7855 66.4535ZM85.9426 63.6724C86.5632 64.561 86.8922 65.617 86.8855 66.6967V84.0035H73.2188V66.6967C73.2122 65.617 73.5412 64.561 74.1618 63.6724C75.5284 61.7015 78.125 58.3535 80.0522 58.3535C81.9794 58.3535 84.5759 61.7015 85.9426 63.6724Z",
    fill: "#FF9349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2202 73.2036V84.0036H66.9881C66.5403 84.0043 66.1206 83.7874 65.867 83.4229C65.6128 83.059 65.5567 82.5943 65.7169 82.181L67.7942 76.7138C68.5843 74.6004 70.6257 73.1984 72.9059 73.2036H73.2202Z",
    fill: "#FF9349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.201 73.2036C89.4813 73.1984 91.5226 74.6004 92.3127 76.7138L94.3901 82.181C94.5502 82.5943 94.4942 83.059 94.2399 83.4229C93.9863 83.7874 93.5666 84.0043 93.1188 84.0036H86.8867V73.2036H87.201Z",
    fill: "#FF9349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.487 35.4036V43.5036H32.2207V35.4036C32.2254 33.9145 33.4466 32.7082 34.954 32.7036H108.754C110.261 32.7082 111.483 33.9145 111.487 35.4036Z",
    fill: "#FF9349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4323 81.7082C64.1193 82.5374 64.2368 83.4655 64.7473 84.1926C65.2578 84.9197 66.0966 85.3534 66.9921 85.3534H72.4888L74.8124 88.8029C75.0667 89.1793 75.4951 89.4047 75.9535 89.4034H84.1535C84.6106 89.4034 85.0371 89.178 85.2906 88.8029L87.6182 85.3534H93.1149C94.0105 85.3534 94.8493 84.9197 95.3598 84.1926C95.8703 83.4655 95.9877 82.5374 95.6748 81.7082L93.5974 76.237C92.7252 73.9608 90.6866 72.3195 88.2535 71.9358V66.7032C88.2582 65.3519 87.8485 64.0309 87.0771 62.9149C82.9837 57.0034 80.7776 57.0034 80.0535 57.0034C79.3295 57.0034 77.1233 57.0034 73.03 62.9136C72.2593 64.0303 71.8489 65.3513 71.8535 66.7032V71.9358C69.4212 72.3195 67.3825 73.9588 66.5096 76.2343L64.4323 81.7082ZM83.4295 86.7034H76.6916L75.78 85.3534H84.341L83.4295 86.7034ZM91.0443 77.1816L93.1149 82.6534H88.2535V74.7017C89.5308 75.0386 90.5665 75.9614 91.0376 77.1816H91.0443ZM74.5869 66.7032C74.5829 65.8964 74.8264 65.1067 75.2855 64.439C77.8807 60.6928 79.5397 59.7034 80.0535 59.7034C80.5674 59.7034 82.2263 60.6928 84.8215 64.439C85.2806 65.1067 85.5242 65.8964 85.5202 66.7032V82.6534H74.5869V66.7032ZM69.0695 77.1816C69.5406 75.9614 70.5763 75.0386 71.8535 74.7017V82.6534H66.9921L69.0695 77.1816Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0526 92.1035C77.0337 92.1035 74.5859 94.5214 74.5859 97.5035C74.5859 100.285 76.7153 105.604 80.0526 105.604C83.3899 105.604 85.5193 100.285 85.5193 97.5035C85.5193 94.5214 83.0715 92.1035 80.0526 92.1035ZM80.0526 102.904C79.0303 102.904 77.3193 99.5219 77.3193 97.5035C77.3193 96.0125 78.5431 94.8035 80.0526 94.8035C81.5621 94.8035 82.7859 96.0125 82.7859 97.5035C82.7859 99.5285 81.0749 102.904 80.0526 102.904Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8208 108.304C97.8115 107.193 97.3444 106.134 96.5269 105.371C95.7094 104.608 94.613 104.207 93.4899 104.26C92.828 102.397 90.9021 101.276 88.9315 101.608C86.9602 101.941 85.5195 103.629 85.5208 105.604H88.2542C88.2542 104.858 88.8661 104.254 89.6208 104.254C90.3756 104.254 90.9875 104.858 90.9875 105.604C90.9862 105.679 90.9802 105.755 90.9681 105.829C90.9094 106.34 91.149 106.839 91.5861 107.117C92.0238 107.395 92.583 107.405 93.0295 107.14C93.2384 107.016 93.4773 106.952 93.7208 106.954C94.4756 106.954 95.0875 107.558 95.0875 108.304C95.0875 109.049 94.4756 109.654 93.7208 109.654H66.3875C65.6328 109.654 65.0208 109.049 65.0208 108.304C65.0208 107.558 65.6328 106.954 66.3875 106.954C66.6311 106.952 66.87 107.016 67.0788 107.14C67.5253 107.405 68.0845 107.395 68.5222 107.117C68.9593 106.839 69.1989 106.34 69.1402 105.829C69.1282 105.755 69.1222 105.679 69.1208 105.604C69.1208 104.858 69.7328 104.254 70.4875 104.254C71.2422 104.254 71.8542 104.858 71.8542 105.604H74.5875C74.5888 103.629 73.1481 101.941 71.1768 101.608C69.2062 101.276 67.2804 102.397 66.6184 104.26C65.4953 104.206 64.3976 104.606 63.5801 105.37C62.7626 106.133 62.2955 107.192 62.2875 108.304C62.2922 108.764 62.3769 109.221 62.5391 109.654H58.1875V112.354H101.921V109.654H97.5692C97.7314 109.221 97.8162 108.764 97.8208 108.304Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0531 62.4033C77.7889 62.4033 75.9531 64.2167 75.9531 66.4533C75.9531 68.6899 77.7889 70.5033 80.0531 70.5033C82.3173 70.5033 84.1531 68.6899 84.1531 66.4533C84.1531 64.2167 82.3173 62.4033 80.0531 62.4033ZM80.0531 67.8033C79.2984 67.8033 78.6865 67.1989 78.6865 66.4533C78.6865 65.7078 79.2984 65.1033 80.0531 65.1033C80.8079 65.1033 81.4198 65.7078 81.4198 66.4533C81.4198 67.1989 80.8079 67.8033 80.0531 67.8033Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0859 86.7036H97.8193V92.1036H95.0859V86.7036Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0859 94.8037H97.8193V97.5037H95.0859V94.8037Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.553 89.4033H103.286V94.8033H100.553V89.4033Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.553 97.5034H103.286V100.203H100.553V97.5034Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2871 86.7036H65.0204V92.1036H62.2871V86.7036Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2871 94.8037H65.0204V97.5037H62.2871V94.8037Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8203 89.4033H59.5536V94.8033H56.8203V89.4033Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8203 97.5034H59.5536V100.203H56.8203V97.5034Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.754 31.3535H34.9535C32.6893 31.3535 30.8535 33.1669 30.8535 35.4035V102.904C30.8535 105.14 32.6893 106.954 34.9535 106.954H59.5535V104.254H34.9535C34.1988 104.254 33.5868 103.649 33.5868 102.904V44.8535H110.12V102.904C110.12 103.649 109.508 104.254 108.754 104.254H100.554V106.954H108.754C111.018 106.954 112.854 105.14 112.854 102.904V35.4035C112.854 33.1669 111.018 31.3535 108.754 31.3535ZM33.5868 42.1535V35.4035C33.5868 34.658 34.1988 34.0535 34.9535 34.0535H108.754C109.508 34.0535 110.12 34.658 110.12 35.4035V42.1535H33.5868Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0527 36.7534H41.7861V39.4534H39.0527V36.7534Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5195 36.7534H47.2529V39.4534H44.5195V36.7534Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9863 36.7534H52.7197V39.4534H49.9863V36.7534Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2871 50.2534H65.0204V52.9534H62.2871V50.2534Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7539 50.2534H70.4872V52.9534H67.7539V50.2534Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2207 50.2534H75.954V52.9534H73.2207V50.2534Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6875 50.2534H81.4208V52.9534H78.6875V50.2534Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9199 36.7534H90.9866V39.4534H60.9199V36.7534Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4199 58.3535H59.5533V61.0535H40.4199V58.3535Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4199 63.7534H59.5533V66.4534H40.4199V63.7534Z",
    fill: "#4C6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4199 69.1533H59.5533V71.8533H40.4199V69.1533Z",
    fill: "#4C6FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 81,
    fill: "white",
    transform: "translate(30.8535 31.3535)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnelTemplates);
export default __webpack_public_path__ + "static/media/funnel_templates.07fe537b25cba6b8dca133e291c636d4.svg";
export { ForwardRef as ReactComponent };